import { logError, logInfo } from "./log";
import { normalizeUrl } from "./normalizeUrl";

export const isDomainResolved = async (url: string): Promise<boolean> => {
  try {
    const normalizedDomain = normalizeUrl(url);
    if (!normalizedDomain) return false;

    const result = await chrome.storage.session.get(["resolvedDomains"]);
    const resolvedDomains = result.resolvedDomains || [];

    logInfo("Resolved domains:", { resolvedDomains, normalizedDomain });

    return resolvedDomains.includes(normalizedDomain);
  } catch (error) {
    logError("Error checking if domain is resolved:", error);
    return false;
  }
};
